import {createSlice} from "@reduxjs/toolkit";
import {pending, rejected} from "../../shared/lib/redux";
import {
    fetchAllTemplates,
    fetchTemplatesByType,
    fetchTemplateById,
    createTemplate,
    updateTemplate,
    deleteTemplate
} from "./templates-operations";

const initialState = {
    templates: [],
    filteredTemplates: [],
    currentTemplate: null,
    loading: false,
    filteredLoading: false,
    error: null,
    filteredError: null,
    templateSelector: {
        templateType: null,
        callback: null,
        continueLabel: null,
        isOpen: false
    }
};

const templatesSlice = createSlice({
    name: "templates",
    initialState,
    reducers: {
        clearCurrentTemplate: (store) => {
            store.currentTemplate = null;
        },
        clearError: (store) => {
            store.error = null;
        },
        openTemplateSelector: (store, {payload}) => {
            store.templateSelector = {
                templateType: payload.templateType,
                callback: payload.callback,
                continueLabel: payload.continueLabel || null,
                isOpen: true
            };
        },
        closeTemplateSelector: (store) => {
            store.templateSelector = {
                templateType: null,
                callback: null,
                continueLabel: null,
                isOpen: false
            };
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchAllTemplates.pending, pending)
            .addCase(fetchAllTemplates.fulfilled, (store, {payload}) => {
                store.loading = false;
                store.templates = payload;
                store.error = null;
            })
            .addCase(fetchAllTemplates.rejected, rejected)
            .addCase(fetchTemplatesByType.pending, (store) => {
                store.filteredLoading = true;
                store.filteredError = null;
            })
            .addCase(fetchTemplatesByType.fulfilled, (store, {payload}) => {
                store.filteredLoading = false;
                store.filteredTemplates = payload;
                store.filteredError = null;
            })
            .addCase(fetchTemplatesByType.rejected, (store, {payload}) => {
                store.filteredLoading = false;
                store.filteredError = payload;
            })
            .addCase(fetchTemplateById.pending, pending)
            .addCase(fetchTemplateById.fulfilled, (store, {payload}) => {
                store.loading = false;
                store.currentTemplate = payload;
                store.error = null;
            })
            .addCase(fetchTemplateById.rejected, rejected)
            .addCase(createTemplate.pending, pending)
            .addCase(createTemplate.fulfilled, (store, {payload}) => {
                store.loading = false;
                store.templates.push(payload);
                store.error = null;
            })
            .addCase(createTemplate.rejected, rejected)
            .addCase(updateTemplate.pending, pending)
            .addCase(updateTemplate.fulfilled, (store, {payload}) => {
                store.loading = false;
                const index = store.templates.findIndex(item => item._id === payload._id);
                if (index !== -1) {
                    store.templates[index] = payload;
                }
                if (store.currentTemplate && store.currentTemplate._id === payload._id) {
                    store.currentTemplate = payload;
                }
                store.error = null;
            })
            .addCase(updateTemplate.rejected, rejected)
            .addCase(deleteTemplate.pending, pending)
            .addCase(deleteTemplate.fulfilled, (store, {payload}) => {
                store.loading = false;
                store.templates = store.templates.filter(item => item._id !== payload._id);
                if (store.currentTemplate && store.currentTemplate._id === payload._id) {
                    store.currentTemplate = null;
                }
                store.error = null;
            })
            .addCase(deleteTemplate.rejected, rejected);
    }
});

export const {clearCurrentTemplate, clearError, openTemplateSelector, closeTemplateSelector} = templatesSlice.actions;
export default templatesSlice.reducer;

